const invitation = {
    find_your_tenants: '找到你的租户',
    find_tenants_description: '您的电子邮件地址可能已经注册了多个租户。您可以选择加入现有租户或继续创建一个新租户。',
    create_new_tenant: '创建一个新的租户',
    email_not_match_title: '您当前以\n{{email}}\n登录',
    email_not_match_description: '请使用正确的帐户登录以接受邀请并成为组织的成员。',
    switch_account: '切换到另一个帐户登录',
    invalid_invitation_status: '无效的邀请。请联系管理员并重试。',
    invitation_not_found: '未找到邀请。请联系管理员。',
};
export default Object.freeze(invitation);
